import { Directive, ElementRef, HostListener, inject, Input, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[appImgFallback]',
  standalone: true
})
export class ImgFallbackDirective {

  private readonly el = inject(ElementRef<HTMLImageElement>)

  @Input() src!: string;
  @Input() appImageFallback: string = '/assets/images/fallback.svg';

  private hasError = false;


  ngOnChanges(changes: SimpleChanges): void {
    if (changes['src']) {
      this.hasError = false;
      this.setImage(this.src);
    }
  }

  @HostListener('error')
  onError() {
    if (!this.hasError && this.appImageFallback) {
      this.hasError = true;
      this.setImage(this.appImageFallback);
    }
  }

  private setImage(url: string) {
    const img = this.el.nativeElement;
    img.src = url || this.appImageFallback;
  }
}
